module.exports = __webpack_public_path__ + "static/media/why_sv.97b2b6c2.vtt";